module.exports = __webpack_public_path__ + "static/media/loadingAnimation.6f50e844.gif";